export default __webpack_public_path__ + "static/media/active-momentum-checkout-banner-mob.93267fbe.png";